import { shallowEqual, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { selectAuthUserRole } from 'data/Auth/selectors'
import { getDefaultAdminRoute } from 'helpers/authHelpers'

/**
 * Catch-all redirect that sends a user to the default route for their role:
 * account managers land on Home, every other admin user lands on Shifts.
 */
const DefaultRedirect = () => {
  const userRole = useSelector(selectAuthUserRole, shallowEqual)
  return <Redirect to={getDefaultAdminRoute(userRole)} />
}

export default DefaultRedirect
